/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { BORDER_RADIUS } from '../../constants/styles';
import styles from './index.styl';

const Paper = ({
  children,
  className,
  disabled,
  gray,
  onClick,
  rounded,
  style,
  transparent,
  unstyled,
  zDepth,
  inset,
  styleName,
  isLayoutColumn,
  overflowVisible,
}) => (
  <div
    {...{ children, className, onClick }}
    style={Object.assign(
      {},
      {
        borderRadius: rounded ? BORDER_RADIUS : 0,
        boxShadow:
          unstyled || disabled
            ? null
            : `${inset ? 'inset' : ''}0 2px ${zDepth}px 0 rgba(0, 0, 0, .1)`,
        opacity: disabled ? '0.5' : null,
      },
      style,
    )}
    styleName={classNames('root', {
      'root--unstyled': unstyled,
      'root--transparent': transparent,
      'root--gray': gray,
      'root--column': isLayoutColumn,
      'root--overflow-visible': overflowVisible,
      styleName,
    })}
  />
);

Paper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  disabled: PropTypes.bool,
  gray: PropTypes.bool,
  onClick: PropTypes.func,
  rounded: PropTypes.bool,
  style: PropTypes.object,
  transparent: PropTypes.bool,
  unstyled: PropTypes.bool,
  zDepth: PropTypes.number,
  inset: PropTypes.bool,
  isLayoutColumn: PropTypes.bool,
  overflowVisible: PropTypes.bool,
};

Paper.defaultProps = {
  disabled: false,
  rounded: true,
  zDepth: 16,
  inset: false,
};

export default CSSModules(Paper, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Paper/index.jsx